import { useTranslate } from '@bynder/localization';
import { IconEdit } from '@bynder/icons';
import { EmptyState, Flex } from '@bynder/design-system';
import { EditModeButton } from '../guides/Header';

const EmptyPage: React.FC<{ canEdit: boolean }> = ({ canEdit }) => {
  const { translate } = useTranslate();

  return (
    <Flex direction="column" justifyContent="center" alignItems="center">
      <EmptyState
        icon={<IconEdit />}
        title={translate('EMPTY_PAGE.TITLE')}
        text={canEdit && translate('EMPTY_PAGE.SUBTITLE')}
        actions={
          canEdit && (
            <>
              <EditModeButton />
            </>
          )
        }
      />
    </Flex>
  );
};

export default EmptyPage;
